import { render, staticRenderFns } from "./UploadImageDialog.vue?vue&type=template&id=6cb87fb4&scoped=true&"
import script from "./UploadImageDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageDialog.vue?vue&type=style&index=0&id=6cb87fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb87fb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDialog,VImg,VTextarea})
